<template>
  <span>{{ computedDate }}</span>
</template>

<script>
import { timeFormat } from '@/utils/comUtils'
export default {
  name: 'commonTime',
  components: {},
  props: {
    time: [String, Number], // 时间戳或者时间字符串
    format: {
      // 时间格式转换类型指定
      type: String,
      validator(value) {
        return (
          [
            'YYYY.MM.DD hh:mm:ss',
            'YYYY.MM.DD hh:mm',
            'YYYY-MM-DD hh:mm:ss',
            'YYYY-MM-DD hh:mm',
            'MM-DD hh:mm',
            'YYYY-MM-DD',
            'hh:mm:ss',
            'hh:mm'
          ].indexOf(value) !== -1
        )
      }
    }
  },
  data() {
    return {
      date: ''
    }
  },
  computed: {
    computedDate() {
      let _result = ''
      if (this.time) {
        _result = timeFormat(new Date(this.time), this.format)
      }
      return _result
    }
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
  filters: {}
}
</script>

<style lang="scss" scoped></style>
